import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { ToastrService } from 'ngx-toastr';
import { AppService } from 'src/app/services/app-service.service';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-add-info',
  templateUrl: './add-info.component.html',
  styleUrls: ['./add-info.component.scss']
})
export class AddInfoComponent {

  images:any = [];
  files:any = [];

  currentFile:any = '';
  currentFileType:any = '';
  siteUrl = environment.siteUrl;
  viewer = 'google';
  constructor(
    private appService: AppService,
    public dialogRef: MatDialogRef<AddInfoComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private toasterService: ToastrService
  ) {

    this.appService.getChapterInfo(data.chapterId).subscribe((res: any) => {
      if(res.additionalInfo) {
        let list = res.additionalInfo.split(',');
        this.currentFile = list[0];
        this.currentFileType = (list[0].includes('.jpeg') || list[0].includes('.png') || list[0].includes('.jpg') || list[0].includes('.svg'))?'image':'file';
        this.images = list.filter((item:any)=>{
          return item.includes('.jpeg') || item.includes('.png') || item.includes('.jpg') || item.includes('.svg');
        });
        this.files = list.filter((item:any)=>{
          return !item.includes('.jpeg') && !item.includes('.png') && !item.includes('.jpg') && !item.includes('.svg');
        })
      } else {
        this.toasterService.warning('This Chapter Don\'t Have Additional Info','No Additional Files')
        this.dialogRef.close();
      }
    })

  }

  contentChange(file:any,type:any) {
    this.currentFile = file;
    this.currentFileType = type;
  }

}
